import React, { forwardRef, useState } from "react";
import { View, TextInput, Pressable } from "react-native";
import { useFormContext } from "@clearabee/ui-library-base";
import { styles } from "./InputText.styles";
import { Text } from "../../../Text/Text";
import { Icon } from "../../../Icon/Icon";
import { theme } from "../../../../theme";
export const InputText = forwardRef(({ error, success, styles: userStyles, prefix, disabled, onBlur, onChange, onFocus, secureTextEntry, ...rest }, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const formContext = useFormContext();
    const handlePasswordVisibility = () => {
        setPasswordVisibility(!passwordVisibility);
    };
    const inputElement = (React.createElement(View, null,
        React.createElement(TextInput, { ref: ref, pointerEvents: disabled ? "none" : "auto", placeholderTextColor: theme.colors.greyscale.lighter, style: [
                styles.input,
                !!prefix && styles.inputPrefix,
                success && styles.success,
                !!error && styles.error,
                disabled && styles.disabled,
                isFocused && styles.onFocus,
                userStyles,
            ], editable: !disabled, onSubmitEditing: () => formContext?.isField ? formContext.handleSubmit() : undefined, autoCorrect: false, ...rest, onFocus: () => {
                onFocus?.();
                setIsFocused(true);
            }, onBlur: () => {
                onBlur?.();
                setIsFocused(false);
            }, onChangeText: (value) => onChange?.(value), secureTextEntry: secureTextEntry && !passwordVisibility }),
        secureTextEntry && (React.createElement(Pressable, { onPress: handlePasswordVisibility, style: styles.visibilityIcon }, passwordVisibility ? (React.createElement(Icon.EyeClosed, { size: "medium", color: "brand.base" })) : (React.createElement(Icon.Eye, { size: "medium", color: "brand.base" }))))));
    if (!prefix) {
        return inputElement;
    }
    return (React.createElement(View, { style: styles.container },
        prefix && (React.createElement(View, { style: styles.prefix },
            React.createElement(Text, null, prefix))),
        inputElement));
});
//# sourceMappingURL=InputText.js.map